const name = 'text-me-the-app';

export default {
  COMPONENT_LOADED: `${name} component loaded`,
  GENERATE_QR_CODE_ERROR: `${name} generate QR code error`,
  GENERATE_QR_CODE_SUCCESS: `${name} generate QR code success`,
};
